const USER_TOKEN_KEY = 'userAuthToken';
const USER_DATA_KEY = 'userProfile';
const ADMIN_TOKEN_KEY = 'adminAuthToken';

const DEFAULT_BACKEND_URL = 'https://clientcodeai.tech';

export const getBackendUrl = () => {
  const configuredUrl = (process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || '').trim();

  if (configuredUrl) {
    return configuredUrl.replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';

    if (isLocalHost) {
      return 'http://localhost:5000';
    }

    return DEFAULT_BACKEND_URL;
  }

  return DEFAULT_BACKEND_URL;
};

export const getUserToken = () => localStorage.getItem(USER_TOKEN_KEY);

export const setUserSession = (token, user) => {
  localStorage.setItem(USER_TOKEN_KEY, token);
  localStorage.setItem(USER_DATA_KEY, JSON.stringify(user || {}));
};

export const clearUserSession = () => {
  localStorage.removeItem(USER_TOKEN_KEY);
  localStorage.removeItem(USER_DATA_KEY);
};

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);

export const setAdminSession = (token) => {
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
};

export const clearAdminSession = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
};
